/**
 * Améliore l'accessibilité des boutons Judge.me
 * Ajoute des aria-label aux boutons de navigation du carousel
 */

(function() {
  'use strict';

  /**
   * Ajoute les aria-labels aux boutons Judge.me
   */
  function addAriaLabels() {
    // Trouver tous les boutons Judge.me dans chaque carousel
    const carousels = document.querySelectorAll('[id*="judge_me_reviews_testimonials_carousel"]');
    
    carousels.forEach(carousel => {
      // Trouver tous les boutons .jdgm-arrow dans ce carousel
      const buttons = carousel.querySelectorAll('.jdgm-arrow');
      
      buttons.forEach((button, index) => {
        // Ne pas modifier si l'aria-label existe déjà
        if (button.getAttribute('aria-label')) {
          return;
        }
        
        // Le premier bouton (index 0) = Carte précédente
        // Le deuxième bouton (index 1, nth-child(2)) = Carte suivante
        if (index === 0) {
          button.setAttribute('aria-label', 'Carte précédente');
        } else if (index === 1) {
          button.setAttribute('aria-label', 'Carte suivante');
        }
      });
    });
    
    // Fallback : si pas de carousel trouvé, chercher directement les boutons
    // et utiliser la position dans leur conteneur parent
    const allButtons = document.querySelectorAll('.jdgm-arrow');
    if (allButtons.length > 0 && !allButtons[0].getAttribute('aria-label')) {
      allButtons.forEach((button, index) => {
        if (!button.getAttribute('aria-label')) {
          if (index === 0) {
            button.setAttribute('aria-label', 'Carte précédente');
          } else if (index === 1) {
            button.setAttribute('aria-label', 'Carte suivante');
          }
        }
      });
    }
  }

  /**
   * Initialise l'amélioration de l'accessibilité
   */
  function init() {
    // Exécuter immédiatement au cas où les boutons sont déjà présents
    addAriaLabels();

    // Observer les changements du DOM pour détecter les boutons ajoutés dynamiquement
    const observer = new MutationObserver((mutations) => {
      let shouldCheck = false;
      
      mutations.forEach((mutation) => {
        if (mutation.addedNodes.length > 0) {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === 1) { // Element node
              // Vérifier si le nœud ajouté contient des boutons Judge.me
              if (node.classList && node.classList.contains('jdgm-arrow')) {
                shouldCheck = true;
              } else if (node.querySelector && node.querySelector('.jdgm-arrow')) {
                shouldCheck = true;
              }
            }
          });
        }
      });

      if (shouldCheck) {
        addAriaLabels();
      }
    });

    // Observer les changements dans le document
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Vérifier périodiquement au cas où l'observer ne détecte pas tout
    // (surtout utile pour Judge.me qui peut injecter du contenu de manière asynchrone)
    const intervalId = setInterval(() => {
      const buttons = document.querySelectorAll('.jdgm-arrow');
      if (buttons.length > 0) {
        addAriaLabels();
        // Arrêter l'intervalle après quelques vérifications pour éviter de surcharger
        if (buttons.length > 0 && buttons[0].getAttribute('aria-label')) {
          clearInterval(intervalId);
        }
      }
    }, 500);

    // Arrêter l'intervalle après 10 secondes maximum
    setTimeout(() => {
      clearInterval(intervalId);
    }, 10000);
  }

  // Attendre que le DOM soit prêt
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Également s'exécuter après le chargement complet de la page
  // (au cas où Judge.me charge après DOMContentLoaded)
  window.addEventListener('load', () => {
    setTimeout(addAriaLabels, 1000);
  });
})();

